<!--   
    Setting for a single Channel(Alarm) for a device
    Saving a new Object here when no alarm is given, needs to create a new alarm

-->
<!--Copy right - © 2024 tecera gmbh-->

<script>
    import { onMount } from "svelte";
    import { user_permissions, logout, user_role } from "../scripts/auth.js";
    export let channel;

    let alarm = channel.alarms[0];
    let is_checked = alarm.autoquit == 1 ? true : false;
    let is_boolean = channel.boolean_0 == null ? false : true;
    let user_has_write_permission = $user_role["set_alarm"] && $user_role["set_alarm"]==1 ? true : false;
    var icon_dictionary = {
        Hydrantendeckel: "fa fa-sun",
        Magnetring: "fa fa-link",
        Wasserdruck: "fa fa-water",
        Batteriestatus: "fa fa-bolt",
        Default: "fa fa-check-square",
    };

    $: {
        alarm.autoquit = is_checked ? 1 : 0;
    }

    $: {
        if (!is_boolean) {
            alarm.min_alarm_active =
                alarm.min_threshold == null || alarm.min_threshold == ""
                    ? 0
                    : 1;
            alarm.max_alarm_active =
                alarm.max_threshold == null || alarm.max_threshold == ""
                    ? 0
                    : 1;
        }
    }

    let is_open = false;

    onMount(() => {
        const handleClickOutside = (event) => {
            if (is_open && !event.target.closest(".dropdown-toggle")) {
                is_open = false;
            }
        };

        document.addEventListener("click", handleClickOutside);

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    });
    let selected_option;

    if (is_boolean) {
        if (alarm.min_alarm_active == 0 && alarm.max_alarm_active == 0) {
            selected_option = "kein Alarm";
        } else if (alarm.min_alarm_active == 1) {
            selected_option = channel.boolean_0;
        } else if (alarm.max_alarm_active == 1) {
            selected_option = channel.boolean_1;
        }
    } else {
        //TODO implement
    }
</script>

<p class="p-h1 mt-3">{channel.measurand}</p>
<div class="input-group mb-2 mt-0">
    <p class="p-h3">Automatische Quittierung</p>
    <label class="switch ml-4 mt-2"
        ><input type="checkbox" bind:checked={is_checked} disabled={!user_has_write_permission}/><span
            class="slider round"
        ></span></label
    >
</div>

{#if is_boolean}
    <div class="row centered-content">
        <div class="col-1 white grenzen-text">
            <i class={icon_dictionary[channel.measurand] ? icon_dictionary[channel.measurand] : icon_dictionary["Default"]}></i>
        </div>
        <div class="col-5 white grenzen-text">Alarm</div>
        <div class="col-6">
            <div class="mb-2 mt-0 grenzen-input">
                <button
                    class="btn form-control py-1 grenzen-field dropdown-toggle {user_has_write_permission ? "" : "disabled"}"
                    data-display="static"
                    id="phototransistor"
                    on:click={() => {if(user_has_write_permission){is_open = !is_open}}}
                    >{selected_option}</button
                >
                <div
                    class="dropdown-menu filter_dropdown mt-2 {is_open
                        ? 'show'
                        : ''}"
                    aria-labelledby="phototransistor"
                >
                    <div
                        class="filter_dropdown_scrollable pl-2 pr-2"
                        id="selection_phototransistor"
                    >
                        <button
                            class="btn btn-primary btn-block btn-normal"
                            on:click={() => {
                                selected_option = channel.boolean_0;
                                alarm.min_alarm_active = 1;
                                alarm.max_alarm_active = 0;
                            }}>{channel.boolean_0}</button
                        ><button
                            on:click={() => {
                                selected_option = channel.boolean_1;
                                alarm.min_alarm_active = 0;
                                alarm.max_alarm_active = 1;
                            }}
                            class="btn btn-primary btn-block btn-normal"
                            >{channel.boolean_1}</button
                        ><button
                            on:click={() => {
                                selected_option = "kein Alarm";
                                alarm.min_alarm_active = 0;
                                alarm.max_alarm_active = 0;
                            }}
                            class="btn btn-primary btn-block btn-normal"
                            >kein Alarm</button
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
{:else}
    <div class="row centered-content">
        <div class="col-1 white grenzen-text">
            <i class="fa fa-droplet"></i>
        </div>
        <div class="col-5 white grenzen-text">Min ({channel.unit})</div>
        <div class="col-6">
            <div class="input-group grenzen-input">
                <input
                    class="form-control py-1 grenzen-field {user_has_write_permission ? "" : "custom-disabled"}"
                    type="text"
                    aria-label="search"
                    maxlength="8"
                    autocomplete="off"
                    id="volumenstrom_min"
                    placeholder="Wert"
                    bind:value={alarm.min_threshold}
                />
                {#if user_has_write_permission }
                <button
                    class="btn bg-transparent btn-clear white"
                    class:hidden={alarm.min_threshold == null ||
                        alarm.min_threshold == ""}
                    value="volumenstrom_min"
                    on:click={() => (alarm.min_threshold = null)}
                    ><i class="fa fa-times"></i></button
                >
                {/if}
            </div>
        </div>
    </div>
    <div class="row centered-content mt-2">
        <div class="col-1 white grenzen-text">
            <i class="fa fa-droplet"></i>
        </div>
        <div class="col-5 white grenzen-text">Max ({channel.unit})</div>
        <div class="col-6">
            <div class="input-group grenzen-input">
                <input
                    class="form-control py-1 grenzen-field {user_has_write_permission ? "" : "custom-disabled"}"
                    type="text"
                    aria-label="search"
                    maxlength="8"
                    autocomplete="off"
                    id="volumenstrom_max"
                    placeholder="Wert"
                    bind:value={alarm.max_threshold}
                />
                {#if user_has_write_permission }
                <button
                    class="btn bg-transparent btn-clear white"
                    class:hidden={alarm.max_threshold == null ||
                        alarm.max_threshold == ""}
                    value="volumenstrom_max"
                    on:click={() => (alarm.max_threshold = null)}
                    ><i class="fa fa-times"></i></button
                >
                {/if}
            </div>
        </div>
    </div>
{/if}
